const WelcomeCardStyle = {
  welcomeCardContainerStyle: {
    width: "100%",
    padding: "30px 30px",
    paddingBottom: 0,
    "@media only screen and (max-width: 768px)": {
      padding: "20px 20px",
      paddingBottom: 0,
    },
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  welcomeCardTextStyle: {
    color: "#383D4E",
    fontSize: "20px",
    fontWeight: 400,
    fontFamily: "Playfair Display",
    paddingBottom: "0.5rem"
  },
  welcomeCardStyle: {
    flexShrink: 0,
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    marginTop: "22px",
    padding: "25px 30px",
    background: "linear-gradient(108deg, #FFF 80.85%, #F8F9FF 145.84%)",
    filter: "drop-shadow(20px 20px 57px rgba(0, 0, 0, 0.08))",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    "@media only screen and (max-width: 768px)": {
      gap: "15px",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr 1fr",
      alignItems: "center",
    },
  },
  welcomeCardItemStyle: {
    display: "flex",
    alignItems: "center",
    gap: "20.19px",
    cursor: "pointer",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "10px",
      img: {
        height: "40px",
      },
    },
  },
  WelcomCardItemTextStyle: {
    color: "#1D252B",
    fontSize: "20px",
    fontWeight: 300,
    fontFamily: "Noto Sans",
    "@media (max-width: 599px)": {
      fontFamily: "Lato",
      textAlign: "center",
    },
    "@media (max-width: 992px)": {
      fontSize: "16px",
    },
  },
  inputStyles: {
    padding: "10px",
    borderRadius: "50px",
    width: "50%",
    outline: "none",
    border: "1px solid #cccccc",
    fontFamily: `ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI Variable Display", "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`,
  },
};

export default WelcomeCardStyle;
